import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Apply for all variants ")
const _hoisted_3 = { class: "order-item-artwork-custom p-1 order-artwork h-100" }
const _hoisted_4 = {
  key: 1,
  class: "avatar-uploader-icon text-primary",
  style: {"height":"300px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { class: "text-primary" }, "Click to upload", -1)
const _hoisted_6 = { class: "flex items-center pl-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"vertical-align":"middle"} }, "Preview", -1)
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"vertical-align":"middle"} }, "Clear", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold mb-3" }, "Image URL:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_View = _resolveComponent("View")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Upload Artwork Image",
      width: "40%",
      top: "8vh"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", null, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSave()))
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { class: "flex items-center justify-between" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.isApplyForAllVariants,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isApplyForAllVariants) = $event)),
              title: "The artwork will apply for all variants of this product"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeTabName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTabName) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "Upload from computer",
              name: "uploadFile",
              class: "flex"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    "auto-upload": false,
                    "show-file-list": false,
                    title: "Click to upload",
                    onChange: _ctx.onUploadDesign,
                    accept: "image/*",
                    style: {"width":"300px"}
                  }, {
                    default: _withCtx(() => [
                      (_ctx.uploadedFileUrl)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            src: _ctx.uploadedFileUrl
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                      (!_ctx.uploadedFileUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("p", null, [
                              _createVNode(_component_el_icon, { style: {"font-size":"30px"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_upload_filled)
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_5
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onChange"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _ctx.onClickPreviewImage
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_View)
                            ]),
                            _: 1
                          }),
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("p", _hoisted_8, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _ctx.onClearUploadedFile
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Refresh)
                            ]),
                            _: 1
                          }),
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "Upload by URL",
              name: "uploadUrl",
              class: "image-preview"
            }, {
              default: _withCtx(() => [
                (_ctx.inputFileUrl)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      src: _ctx.inputFileUrl,
                      "preview-src-list": [_ctx.inputFileUrl],
                      class: "border",
                      style: {"width":"300px"}
                    }, null, 8, ["src", "preview-src-list"]))
                  : _createCommentVNode("", true),
                _hoisted_10,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.inputFileUrl,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputFileUrl) = $event)),
                  rows: 5,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_PreviewImage, {
      url: _ctx.uploadedFileUrl,
      ref: "previewImageDialog"
    }, null, 8, ["url"])
  ], 64))
}